<ion-button
  (click)="onExitQuestionnaire()"
  color="medium"
  class="close-button"
  fill="clear"
>
  <ion-icon name="close" slot="end" />
  Afsluiten
</ion-button>
